export default function BrandTitle(){
 return <><h1 className="mt-4 text-2xl font-bold text-gray-900">Vantage</h1><p className="text-sm text-gray-500">by Velosynt</p></>;
}
